import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconAssignmentTurnedIn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.6667 1.99935H9.88C9.6 1.22602 8.86667 0.666016 8 0.666016C7.13333 0.666016 6.4 1.22602 6.12 1.99935H3.33333C2.6 1.99935 2 2.59935 2 3.33268V12.666C2 13.3993 2.6 13.9993 3.33333 13.9993H12.6667C13.4 13.9993 14 13.3993 14 12.666V3.33268C14 2.59935 13.4 1.99935 12.6667 1.99935ZM8 1.99935C8.36667 1.99935 8.66667 2.29935 8.66667 2.66602C8.66667 3.03268 8.36667 3.33268 8 3.33268C7.63333 3.33268 7.33333 3.03268 7.33333 2.66602C7.33333 2.29935 7.63333 1.99935 8 1.99935ZM6.66667 11.3327L4 8.66602L4.94 7.72602L6.66667 9.44602L11.06 5.05268L12 5.99935L6.66667 11.3327Z",
		fill: "#333333"
	})
});
export default SvgIconAssignmentTurnedIn;
